import React from 'react'

import { AuthContext } from '../../main/ProvedorAutenticacao'
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable' 
import { Column } from 'primereact/column'
import { Toast } from 'primereact/toast';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import PessoaService from '../../app/service/PessoaService'

import imagemRelatorio from '../../img/jvaRelatorio.png'

import './fichaPessoa.css'

class FichaPessoa extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pessoa: null,
      nome: '',
      cpfCnpj: '',
      rg: '',
      tipoPessoa: '',
      perfilPessoa: '',
      status: '',
      telefone1: '',
      telefone2: '',
      email: '',
      endereco: '',
      cep: '',
      bairro: '',
      cidade: '',
      estado: '',
      unidade: '',
      dataNascimento: '',
      dataCadastro: '',
      naturaliade: '',
      nacionalidade: '',
      grupoPessoa: '',
      nomeMae: '',
      nomePai: '',
      profissao: '',
      estadoCivil: '',
      observacao: '',
      openSpinner: false,
      //Processos
      processos: [],
    }

    this.pessoaService = new PessoaService();
  }

  consultarProcessos = async (pessoa) => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.pessoaService.consultarProcessos(pessoa, usuarioLogado.codigo)
      .then(response => {
        this.setState({processos: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarPessoa = async (codigo) => {
    await this.pessoaService.consultarPessoa(codigo)
      .then(response => {
        this.setState({pessoa: response.data});
        this.setState({codigo: response.data.codigo});
        this.setState({nome: response.data.nome});
        this.setState({cpfCnpj: response.data.cpfCnpj});
        this.setState({rg: response.data.rg});
        if(response.data.tipoPessoa === 'F') {
          this.setState({tipoPessoa: 'FÍSICA'})
        } else {
          this.setState({tipoPessoa: 'JURÍDICA'})
        }
        this.setState({perfil: response.data.perfil.nome})
        if(response.data.status == 0) {
          this.setState({status: 'ATIVO'});
        } else {
          this.setState({status: 'INATIVO'});
        }

        this.setState({enderecos: response.data.enderecos});
        this.setState({contatos: response.data.contatos})
        
        this.setState({grupoPessoa: response.data.grupoCliente.nome});
        this.setState({unidade: response.data.unidadeAtendimento.nome})
        if(response.data.dataNascimento != '') {
          this.setState({dataNascimento: this.formatarData(response.data.dataNascimento)});
        }

        if(response.data.dataCadastro != '') {
          this.setState({dataCadastro: this.formatarData(response.data.dataCadastro)});
        }

        if(response.data.estadoCivil != null) {
          this.setState({estadoCivil: response.data.estadoCivil.nome});
        }

        this.setState({profissao: response.data.profissao});
        this.setState({observacao: response.data.observacao});
        this.setState({nomeMae: response.data.nomeMae});
        this.setState({nomePai: response.data.nomePai});
        this.setState({naturalidade: response.data.naturalidade});
        this.setState({nacionalidade: response.data.nacionalidade});
        this.consultarProcessos(response.data.codigo);
      }).catch(error => {
        console.log('Erro ', error);
      })
  }

  formatarData(dataString) {
    const partes = dataString.split("-"); // divide em [yyyy, MM, dd]
    const ano = partes[0];
    const mes = partes[1];
    const dia = partes[2];
  
    return `${dia}/${mes}/${ano}`;
  }

  async componentDidMount() {
    const params = this.props.match.params;
    if(params.codigo) {
      this.setState({openSpinner: true});
      await this.consultarPessoa(params.codigo);
      this.setState({openSpinner: false});
    }
  }

  render() {
    return(
      <>
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        <br></br>
        <body className="corpo">
          <div className="imagem">
            <img src={imagemRelatorio} width="400" height="140"/>
          </div>
          <h1 className="cor">FICHA CADASTRAL DO CLIENTE</h1>
          <div className="imprimir">
          <button onClick={() => window.print()} className="no-print">
            Imprimir
          </button>
          </div>
          <h2 className="cor">Dados Pessoais</h2>
          <div className="row2">
              <div className="field"><span className="label">Nome Completo</span><span className="label2">{this.state.nome}</span></div>
              <div className="field"><span className="label">Ttipo de Pessoa</span><span className="label2">{this.state.tipoPessoa}</span></div>
              <div className="field"><span className="label">CPF/CNPJ</span><span className="label2">{this.state.cpfCnpj}</span></div>
              <div className="field"><span className="label">RG</span><span className="label2">{this.state.rg}</span></div>
          </div>
          <div className="row2">
              <div className="field"><span className="label">Perfil da Pessoa</span><span className="label2">{this.state.perfil}</span></div>
              <div className="field"><span className="label">Status</span><span className="label2">{this.state.status}</span></div>
              <div className="field"><span className="label"></span></div>
              <div className="field"><span className="label"></span></div>
          </div>

          <h2 className="cor">Contatos</h2>
          

          <div>
            {this.state.contatos && this.state.contatos.length > 0 ? (
              this.state.contatos.map((contato, index) => {
                // Monta dinamicamente apenas os campos existentes
                const partes = [
                  contato.tipoTelefone,
                  contato.telefone,
                  contato.email,
                ].filter(Boolean); // remove undefined, null e string vazia

                return (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "8px",
                      fontSize: "16px",
                      fontWeight: "bold",
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    {/* String formatada apenas com os valores existentes */}
                    <span>{partes.join(" - ")}</span>

                  </div>
                );
              })
            ) : (
              <p style={{ fontSize: "14px", color: "#666" }}>Nenhum contato cadastrado</p>
            )}
          </div>

          <h2 className="cor">Endereço</h2>
          
        <div>
            {this.state.enderecos && this.state.enderecos.length > 0 ? (
              this.state.enderecos.map((endereco, index) => {
                // Monta dinamicamente apenas os campos existentes
                const partes = [
                  endereco.tipoEndereco,
                  endereco.endereco,
                  endereco.bairro,
                  endereco.cep,
                  endereco.complemento,
                  endereco.cidade?.nome,
                  endereco.cidade?.estado?.estado,
                ].filter(Boolean); // remove undefined, null e string vazia

                return (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "8px",
                      fontSize: "16px",
                      fontWeight: "bold",
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    {/* String formatada apenas com os valores existentes */}
                    <span>{partes.join(" - ")}</span>

            
                  </div>
                );
              })
            ) : (
              <p style={{ fontSize: "14px", color: "#666" }}>Nenhum endereço cadastrado</p>
            )}
          </div>



          <br></br>

          <div class="row2">
            <div className="field"><span className="label">Unidade</span><span className="label2">{this.state.unidade}</span></div>
            <div className="field"><span className="label">Grupo Pessoas</span><span className="label2">{this.state.grupoPessoa}</span></div>
          </div>

          <h2 className="cor">Informações Complementares</h2>

          <div className="row2">
              <div class="field"><span className="label">Data de Nascimento</span><span className="label2">{this.state.dataNascimento}</span></div>
              <div class="field"><span className="label">Data de Cadastro</span><span className="label2">{this.state.dataCadastro}</span></div>
          </div>
          <div className="row2">
              <div className="field"><span className="label">Naturalidade</span><span className="label2">{this.state.naturalidade}</span></div>
              <div className="field"><span className="label">Nacionalidade</span><span className="label2">{this.state.nacionalidade}</span></div>
          </div>
          <div className="row2">
              <div className="field"><span className="label">Estado Civil</span><span className="label2">{this.state.estadoCivil}</span></div>
              <div className="field"><span className="label">Profissão</span><span className="label2">{this.state.profissao}</span></div>
          </div>
          <div className="row2">
              <div className="field"><span className="label">Nome da Mãe</span><span className="label2">{this.state.nomeMae}</span></div>
              <div className="field"><span className="label">Nome do Pai</span><span className="label2">{this.state.nomePai}</span></div>
          </div>

          <h2 className="cor">Observações</h2>
          <div className="observacoes">
            <span className="label2">{this.state.observacao}</span>
          </div>
          <h2 className="cor">Processos</h2>
          <div>
            <table style={{ 
                width: "100%", 
                borderCollapse: "collapse",
                fontSize: "18px"   // aumenta fonte geral
              }}>
              <thead>
                <tr>
                  <th style={{ 
                      padding: "10px 0",
                      fontSize: "20px",   // fonte maior dos títulos
                      fontWeight: "bold",
                      border: "none"
                    }}>
                    Número do Processo
                  </th>
                  <th style={{ 
                      padding: "10px 0",
                      fontSize: "20px",
                      fontWeight: "bold",
                      border: "none"
                    }}>
                    Número do CNJ
                  </th>
                  <th style={{ 
                      padding: "10px 0",
                      fontSize: "20px",
                      fontWeight: "bold",
                      border: "none"
                    }}>
                    Partes
                  </th>
                  <th style={{ 
                      padding: "10px 0",
                      fontSize: "20px",
                      fontWeight: "bold",
                      border: "none"
                    }}>
                    Grupo de Trabalho
                  </th>
                </tr>
              </thead>

              <tbody>
                {this.state.processos.map((pro) => (
                  <tr key={pro.codigo}>
                    <td style={{ padding: "8px 0", border: "none" }}>{pro.nrProcesso}</td>
                    <td style={{ padding: "8px 0", border: "none" }}>{pro.nrCnj}</td>
                    <td style={{ padding: "8px 0", border: "none" }}>{pro.montaPartes}</td>
                    <td style={{ padding: "8px 0", border: "none" }}>{pro.grupoTrabalho.nome}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </body>
      </>
    );
  }
}
FichaPessoa.contextType = AuthContext;
export default withRouter(FichaPessoa)